/* eslint-disable */
import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { toast } from "sonner";
import { Download, RefreshCw } from "lucide-react";

const PAYMENT_BADGES = {
  paid: { label: "Plătit", bg: "#22C55E", color: "white" },
  pending: { label: "În așteptare", bg: "#FBBF24", color: "#111C30" },
  failed: { label: "Eșuat", bg: "#EF4444", color: "white" },
  unpaid: { label: "Neplătit", bg: "#94A3B8", color: "white" },
};

export default function AdminPayments() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = () => {
    setLoading(true);
    api.get("/admin/payments")
      .then((r) => setData(r.data))
      .catch(() => toast.error("Eroare la încărcare"))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const exportCsv = () => {
    const token = localStorage.getItem("offerai_token");
    window.open(`${API}/admin/payments/export.csv?auth=${token}`, "_blank");
  };

  if (loading) return <div className="text-sm text-[#94A3B8]">Se încarcă plățile...</div>;
  if (!data) return null;

  const txs = data.transactions.filter((t) => filter === "all" ? true : t.payment_status === filter);

  return (
    <div data-testid="admin-payments">
      <div className="flex items-start justify-between flex-wrap gap-4 mt-10">
        <div>
          <div className="overline">Plăți</div>
          <h2 className="font-display text-2xl lg:text-3xl font-extrabold tracking-tight mt-2">Tranzacții & Încasări</h2>
        </div>
        <div className="flex gap-2">
          <button onClick={load} className="btn-outline flex items-center gap-2" data-testid="refresh-payments">
            <RefreshCw size={14}/> Reîncarcă
          </button>
          <button onClick={exportCsv} className="btn-primary flex items-center gap-2" data-testid="export-csv-btn">
            <Download size={16}/> Export CSV
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-px bg-[#1E293B] border border-[#1E293B] mt-6">
        <div className="bg-[#0B111D] p-5"><div className="overline">Total tranzacții</div><div className="font-display text-3xl font-extrabold mt-1">{data.totals.count}</div></div>
        <div className="bg-[#0B111D] p-5"><div className="overline">Plătite</div><div className="font-display text-3xl font-extrabold mt-1 text-[#22C55E]">{data.totals.paid_count}</div></div>
        <div className="bg-[#0B111D] p-5"><div className="overline">Venit total (EUR)</div><div className="font-display text-3xl font-extrabold mt-1 text-[#00BFFF]">{data.totals.revenue.toFixed(2)}</div></div>
      </div>

      <div className="flex gap-2 mt-6">
        {["all", "paid", "pending", "failed"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            data-testid={`filter-${f}`}
            className={`px-3 py-1.5 text-xs font-semibold uppercase tracking-wider border ${filter === f ? "bg-[#111C30] text-white border-[#111C30]" : "bg-[#0B111D] text-[#94A3B8] border-[#1E293B] hover:border-[#111C30]"}`}
          >
            {f === "all" ? "Toate" : f === "paid" ? "Plătite" : f === "pending" ? "În așteptare" : "Eșuate"}
          </button>
        ))}
      </div>

      <div className="border border-[#1E293B] mt-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#111C30] text-white">
            <tr>
              <th className="text-left p-3 font-display">Data</th>
              <th className="text-left p-3 font-display">Client</th>
              <th className="text-left p-3 font-display">Plan</th>
              <th className="text-right p-3 font-display">Sumă</th>
              <th className="text-left p-3 font-display">Status</th>
              <th className="text-left p-3 font-display">Session ID</th>
            </tr>
          </thead>
          <tbody>
            {txs.length === 0 && (
              <tr><td colSpan="6" className="p-8 text-center text-[#94A3B8]">Nicio tranzacție</td></tr>
            )}
            {txs.map((t) => {
              const badge = PAYMENT_BADGES[t.payment_status] || PAYMENT_BADGES.unpaid;
              return (
                <tr key={t.session_id} className="border-b border-[#1E293B]">
                  <td className="p-3 text-xs font-mono-plex text-[#94A3B8]">{(t.created_at || "").slice(0,16).replace("T", " ")}</td>
                  <td className="p-3">
                    <div className="font-semibold">{t.user_email}</div>
                    <div className="text-xs text-[#94A3B8]">{t.user_name}</div>
                  </td>
                  <td className="p-3 font-mono-plex text-xs uppercase">{(t.metadata || {}).plan_id || t.plan_id || "-"}</td>
                  <td className="p-3 text-right font-mono-plex font-semibold">{Number(t.amount || 0).toFixed(2)} {(t.currency || "").toUpperCase()}</td>
                  <td className="p-3">
                    <span className="font-mono-plex text-xs px-2 py-1" style={{background: badge.bg, color: badge.color}}>{badge.label}</span>
                  </td>
                  <td className="p-3 text-xs font-mono-plex text-[#94A3B8]" title={t.session_id}>{(t.session_id || "").slice(0,16)}…</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
